import {DialogContent, ListItemIcon, styled, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';

const StyledDialogContent = styled(DialogContent)`
	padding: 16px;
	max-width: 500px;

	${({theme}) => theme.breakpoints.up('md')} {
		padding: 24px 24px 32px 24px;
	}
`;

const StyledListItemIcon = styled(ListItemIcon)`
	min-width: initial;

	& > svg {
		color: ${({theme}) => theme.palette.primary.main};
	}
`;

const StyledIconIllustration = styled(IconIllustration)`
	margin: 0 auto;

	${({theme}) => theme.breakpoints.down('sm')} {
		display: none;
	}
`;

const StyledText = styled(Typography)`
	${({theme}) => theme.breakpoints.up('sm')} {
		text-align: center;
	}
`;

export {StyledDialogContent, StyledIconIllustration, StyledListItemIcon, StyledText};
